import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { fetchData, postData, updateData, fetchCountHistory, fetchCountDetails, fetchAppointmentDetails, fetchAppointmentList } from '../../../apiService';
import ArrowForward from '@mui/icons-material/ArrowForward';
import AddIcon from '@mui/icons-material/Add';
import Container from '@mui/material/Container';
import { Card, CardContent, IconButton, Icon, Tooltip, TableCell, Checkbox, Typography, } from '@mui/material';
import Button from '@mui/material/Button';
import { tokenIsExpired } from '../../../authUtils';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import CircularProgress from '@mui/material/CircularProgress';
import TableRow from '@mui/material/TableRow';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import CancelIcon from '@mui/icons-material/Cancel';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import WorkspacesIcon from '@mui/icons-material/Workspaces';

const Allocaterequest = () => {
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [customerNameOptions, setCustomerNameOptions] = useState([]);
    const [Remark, setRemark] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout, companyId]);

    const fetchCustomerNames = async () => {
        try {
            const response = await fetchData('CustomerApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setCustomerNameOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Names:', error);
        }
    };

    useEffect(() => {
        fetchCustomerNames();
    }, []);

    const [formData, setFormData] = useState({
        RequestID: '',
        CompanyID: '',
        WarrentyStatusID: '',
        workstatus: '',
        customer: '',
        Product: '',
        ServiceRequestTypes: '',
        warranty: '',
        StaffAppointmentID: '',
        Remarks: '',
        address: '',
        email: '',
        landmark: '',
        number: '',
        contactperson: '',
        customertype: '',
        pincode: '',
    });

    const [serviceRequestId, setServiceRequestId] = useState('');
    useEffect(() => {
        fetchData('RequestdetailsApi', `/RequestDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                    setServiceRequestId(response.response_data.requestID);
                    console.log(response);
                }
            })
            .catch((error) => {
                console.error('Error fetching Customer Details:', error);
            });
    }, [id]);

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        // Validate form data here if needed

        updateData('CustomerApi', `${id}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/ServiceRequestIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    //Warrenty Type
    const [warrantyTypeOptions, setWarrantyTypeOptions] = useState([]);
    const [selectedWarrantyType, setSelectedWarrantyType] = useState("");

    const fetchWarrantyTypes = async () => {
        try {
            const response = await fetchData('WarrentyStatusApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setWarrantyTypeOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Warrenty Types:', error);
        }
    };

    //Work Type
    const [workTypeOptions, setWorkTypeOptions] = useState([]);
    const [selectedWorkType, setSelectedWorkType] = useState("");

    const fetchWorkTypes = async () => {
        try {
            const response = await fetchData('WorkStatusApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setWorkTypeOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Work Types:', error);
        }
    };

    //Request Type
    const [requestTypeOptions, setRequestTypeOptions] = useState([]);
    const [selectedRequestType, setSelectedRequestType] = useState("");

    const fetchRequestTypes = async () => {
        try {
            const response = await fetchData('ServiceRequestTypeApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setRequestTypeOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Request Types:', error);
        }
    };

    //Product Type
    const [productTypeOptions, setProductTypeOptions] = useState([]);
    const [selectedProductType, setSelectedProductType] = useState("");

    const fetchProductTypes = async () => {
        try {
            const response = await fetchData('ProductApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setProductTypeOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Product Types:', error);
        }
    };

    useEffect(() => {
        fetchWarrantyTypes();
        fetchWorkTypes();
        fetchRequestTypes();
        fetchProductTypes();
    }, []);

    const formatCurrentDate = () => {
        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const year = currentDate.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const [staffNames, setStaffNames] = useState([]);
    const [selectedStaffId, setSelectedStaffId] = useState(null);
    const fetchStaffNames = async () => {
        try {
            const response = await fetchData('StaffApi', `/${companyId}`);

            if (response.responseCode === '1111') {
                setStaffNames(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Staff Names:', error);
        }
    };

    useEffect(() => {
        fetchStaffNames();
    }, []);



    const [showContainer, setShowContainer] = useState(false);
    const handlePlusIconClick = () => {
        setShowContainer(!showContainer);
    };


    const [engineerAvailability, setEngineerAvailability] = useState([]);

    useEffect(() => {
        fetchtableData();
    }, []);

    const formattedDate = new Date().toISOString().split('T')[0];
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);

    const [staffAppointmentId, setStaffAppointmentId] = useState('');
    const [engineerId, setEngineerId] = useState('');

    const fetchtableData = async () => {
        // fetchData('StaffAvailabilityApi', `/${companyId}?date=${toDate}`, token)

        fetchData('StaffAvailabilityApi', `/${toDate}/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    console.log(response);
                    setEngineerAvailability(response.response_data);

                    const firstEngineerAvailability = response.response_data[0];
                    if (firstEngineerAvailability) {
                        setToDate(firstEngineerAvailability.allocatedDate.substring(0, 10));
                        setStaffAppointmentId(response.response_data.staffAppointmentId);
                        // setEngineerId(response.response_data.engineerId);
                        setEngineerId(response.response_data.map(item => item.engineerId));
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching Request Details:', error);
            });
    };


    const submitData = async (e) => {
        e.preventDefault();

        try {
            const RequestCreateData = {

                CompanyID: companyId,
                WorkStatusID: 2,
                ServiceRequestID: serviceRequestId,
                StaffAppointmentID: staffAppointmentId,
                Remarks: Remark,
                AllocatedBy: userId,
                AllocatedDate: formattedDate,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            postData('StaffAvailabilityApi', RequestCreateData, token)
                .then((response) => {
                    console.log('Request Created success:', response);

                    setSuccessMessage("customer Created successful!");
                    // history.push('/ServiceRequestIndex');
                    history.push('/Home');
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Request Create error:', error);
                });
        }
        catch (error) {
            console.error('Request Create error:', error);
        }
    };

    const [selectedCheckboxIndex, setSelectedCheckboxIndex] = useState(null);

    const handleCheckboxChange = (event, index) => {
        try {
            setSelectedCheckboxIndex(index);
            const selectedEngineer = engineerAvailability[index];
            setStaffAppointmentId(selectedEngineer.staffAppointmentId);
        } catch (error) {
            console.error('Error occurred while handling checkbox change:', error);
        }
    };

    const isAnyCheckboxChecked = selectedCheckboxIndex !== null;

    // CHECHING STAFF ON SELECTED DATE 

    const handleToDateChange = (event) => {
        const selectedDate = event.target.value;
        setToDate(selectedDate);
        checkStaffAvailability(selectedDate);
        handleArrowClick(selectedDate);
    }

    const checkStaffAvailability = (selectedDate) => {
        // Perform the API call to check staff availability for the selected date
        fetchData('StaffAvailabilityApi', `/${selectedDate}/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    console.log(response);
                    setEngineerAvailability(response.response_data);
                    // Extracting engineerIds from engineerAvailability array
                    setEngineerId(response.response_data.map(item => item.engineerId));


                    const unavailableStaff = response.response_data.filter(item => !item.Engineeravailability);
                    if (unavailableStaff.length > 0) {
                        alert("Some staff members are not available on the selected date.");
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching Staff Availability:', error);
            });
    }

    // For Display the Services status by engineer

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [data, setData] = useState([]);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const [selectedDate, setSelectedDate] = useState(formattedDate);

    const handleDateChange = (event) => {
        const selectedDate = event.target.value;
        setSelectedDate(selectedDate);
        // Do any additional actions if needed
    };

    const [expandedEngineerId, setExpandedEngineerId] = useState(null);

    const [incompleteserviceCount, setIncompleteserviceCount] = useState(0);


    const handleArrowClick = async (engineerId, index) => {
        try {
            if (expandedEngineerId === engineerId) {
                setExpandedEngineerId(null);
            } else {
                setExpandedEngineerId(engineerId);
            }

            const response = await fetchCountHistory('CountHistoryApi', selectedDate, companyId, engineerId, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
                //setIncompleteserviceCount(response.response_data.length);
                console.log(response);
                openModal();
            } else {
                const responses = await fetchCountDetails('CountHistoryApi', selectedDate, companyId, engineerId, token);
                if (responses.responseCode === '1111') {
                    setData(responses.response_data);
                    openModal();
                }
            }

        } catch (error) {
            console.error('Error occurred while checking status:', error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchCountHistory('CountHistoryApi', toDate, companyId, engineerId, token);
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                } else {
                    const responses = await fetchCountDetails('CountHistoryApi', selectedDate, companyId, engineerId, token);
                    if (responses.responseCode === '1111') {
                        setData(responses.response_data);
                    }
                }
            } catch (error) {
                console.error('Error occurred while fetching data:', error);
            }
        };

        fetchData();
    }, [companyId, selectedDate, engineerId, token]);


    const [toDates, setToDates] = useState(new Date().toISOString().split('T')[0]);
    const [appointmentData, setAppointmentData] = useState([]);
    const [isAppointmentModalOpen, setIsAppointmentModalOpen] = useState(false);

    const handleToScheduledDateChange = (event) => {
        const selectedDate = event.target.value;
        setToDates(selectedDate); // Corrected here
        handleAppointmentClick(companyId, selectedDate); // Pass companyId and selectedDate to the function
    };

    const handleAppointmentClick = async (companyId, selectedDate = toDates) => {
        try {
            const response = await fetchAppointmentList('CountHistoryApi', selectedDate, companyId, token);
            if (response.responseCode === '1111') {
                setAppointmentData(response.response_data);
                console.log(response);
                openAppointmentModal();
            } else {
                const retryResponse = await fetchAppointmentDetails('CountHistoryApi', selectedDate, companyId, token);
                if (retryResponse.responseCode === '1111') {
                    setAppointmentData(retryResponse.response_data);
                    openAppointmentModal();
                } else {
                    console.error('Error: Unable to fetch appointment data on retry:', retryResponse);
                }
            }
        } catch (error) {
            console.error('Error occurred while fetching appointment data:', error);
        }
    };

    const openAppointmentModal = () => setIsAppointmentModalOpen(true);
    const closeAppointmentModal = () => setIsAppointmentModalOpen(false);


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <form onSubmit={updateData}>
                    <div className="w-full mb-2 flex items-center">
                        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>SCHEDULE SERVICE'S</h6>
                        <Tooltip title="Schedule Task">
                            <Button onClick={submitData} style={{ display: isAnyCheckboxChecked ? 'block' : 'none', fontWeight: 'bolder', color: "white", color: 'darkgreen', height: '36px', marginLeft: 'auto', marginRight: 'auto' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "Schedule"}  <ScheduleIcon />
                            </Button>
                        </Tooltip>
                        ||

                        <Tooltip title="Engineer's Appointment summary">
                            <Button onClick={() => handleAppointmentClick(companyId)} style={{ color: 'darkblue', fontWeight: 'bolder' }}>
                                Scheduled Summary <WorkspacesIcon />
                            </Button>
                        </Tooltip>
                        ||
                        <Tooltip title="Exit">
                            <Link to="/Home" style={{ fontWeight: 'bolder', color: 'red', textDecoration: 'none' }}>
                                <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                                    Back To List  <ArrowForwardIosIcon />
                                </Button>
                            </Link>
                        </Tooltip>
                    </div>
                    <br></br>

                    <Modal open={isModalOpen} onClose={closeModal} className={isModalOpen ? 'notification-modal' : ''}>
                        <div className="fixed inset-0 flex items-center justify-center z-10">
                            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1500px' }}>
                                <div className='w-full mb-2 flex justify-end'>
                                    <Tooltip title="Close">
                                        <button className="close-button" onClick={closeModal} style={{ marginLeft: '8px' }}><CancelIcon /></button>
                                    </Tooltip>
                                </div>

                                <h5 style={{ fontFamily: 'monospace', textAlign: 'center', color: 'brown', marginTop: '-25px' }}>Engineer Work Updates</h5>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                            <TableRow>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Allocated Date</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>ReAllocated Date</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Name</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Address</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>ContactNo.</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Product</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Warranty</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>status</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Remarks</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.map((item, index) => (
                                                <TableRow key={item.Id}>
                                                    <TableCell sx={{ fontSize: '12px' }}>{index + 1}</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '4px' }}>
                                                        {item.allocatedDate && new Date(item.allocatedDate).toLocaleDateString('en-GB')}
                                                    </TableCell>
                                                    {/* <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '14px', padding: '4px' ,color:'red'}}>
                                                        {item.reAllocatedDate && new Date(item.reAllocatedDate).toLocaleDateString('en-GB')}
                                                    </TableCell> */}
                                                    <TableCell
                                                        sx={{
                                                            borderBottom: '1px solid #ddd',
                                                            fontWeight: 'bolder',
                                                            fontSize: '12px',
                                                            padding: '4px',
                                                            color: item.reAllocatedDate ? 'red' : 'green'
                                                        }}
                                                    >
                                                        {item.reAllocatedDate ? new Date(item.reAllocatedDate).toLocaleDateString('en-GB') : 'Not found'}
                                                    </TableCell>

                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.customerName}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.addressDetails}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.contactNO}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.productName}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.warrantyStatus}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.serviceStatus}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.remarks}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </Modal>

                    {/* Appointment Summary by Current and selected date*/}
                    <Modal open={isAppointmentModalOpen} onClose={closeAppointmentModal} className={isAppointmentModalOpen ? 'notification-modal' : ''}>
                        <div className="fixed inset-0 flex items-center justify-center z-10">
                            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1500px', marginTop: '-300px' }}>
                                <div className='w-full mb-2 flex justify-end'>
                                    <Tooltip title="Close">
                                        <button className="close-button" onClick={closeAppointmentModal} style={{ marginLeft: '8px' }}><CancelIcon /></button>
                                    </Tooltip>
                                </div>
                                <h5 style={{ fontFamily: 'monospace', textAlign: 'center', color: 'brown' }}>Scheduled Summary</h5>
                                <br></br>
                                <div className="flex justify-end items-center" style={{ marginTop: '-40px' }}>
                                    <label className="block tracking-wide text-black text-xs font-bold mb-2 mr-4" htmlFor="toDates" style={{ fontSize: '17px', fontWeight: 'bolder' }}>
                                        Date
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="date"
                                        id="toDates"
                                        name="toDates"
                                        value={toDates}
                                        onChange={handleToScheduledDateChange}
                                        style={{ width: '150px' }}
                                    />
                                </div>
                                <br></br>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                            <TableRow>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Allocated Date</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>ReAllocated Date</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Engineer</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Name</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Address</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>ContactNo.</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Product</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Warranty</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Status</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '5px', textTransform: 'uppercase' }}>Remarks</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {appointmentData.map((item, index) => (
                                                <TableRow key={item.Id}>
                                                    <TableCell sx={{ fontSize: '16px' }}>{index + 1}</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '14px', padding: '4px', color: 'brown' }}>
                                                        {item.allocatedDate && new Date(item.allocatedDate).toLocaleDateString('en-GB')}
                                                    </TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '14px', padding: '4px', color: 'brown' }}>
                                                        {item.reAllocatedDate && new Date(item.reAllocatedDate).toLocaleDateString('en-GB')}
                                                    </TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', color: 'darkmagenta', fontWeight: 'bolder' }}>{item.engineerName}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.customerName}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.addressDetails}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.contactNO}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.productName}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.warrantyStatus}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.serviceStatus}</TableCell>
                                                    <TableCell sx={{ fontSize: '12px', padding: '4px', }}>{item.remarks}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </Modal>

                    {errorMessage && <div className="text-red-600">{errorMessage}</div>}
                    {successMessage && <div className="text-green-600">{successMessage}</div>}
                </form>
                <div className="flex" style={{ marginTop: '-20px' }}>

                    <div className="w-1/2 pr-4">
                        <div className="bg-blue-850 rounded-lg shadow-lg p-6">

                            <div className="w-full mb-2 flex items-center" style={{ marginTop: '0px' }}>
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="customer" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Call Serial No
                                </label>
                                : <strong style={{ fontSize: '14px', color: 'darkcyan', marginLeft: '5px' }}> {formData.callSerialNo}</strong>
                            </div>
                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="customertype" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Customer Name
                                </label>
                                : <strong style={{ fontSize: '14px', color: 'darkred', marginLeft: '5px' }}> {formData.customer}</strong>
                            </div>
                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="customertype" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Customer-Type
                                </label>
                                : <strong style={{ fontSize: '14px', color: 'darkred', marginLeft: '5px' }}> {formData.customertype}</strong>
                            </div>

                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="number" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Contact.No
                                </label>
                                : <strong style={{ fontSize: '14px', color: 'darkred', marginLeft: '5px' }}> {formData.number}</strong>
                            </div>

                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="address" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Customer Address
                                </label>
                                : <strong style={{ fontSize: '14px', color: 'darkred', marginLeft: '5px' }}> {`${formData.address}, ${formData.landmark}`}</strong>
                            </div>

                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="pincode" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Pincode
                                </label>
                                : <strong style={{ fontSize: '14px', color: 'darkred', marginLeft: '5px' }}> {formData.pincode}</strong>
                            </div>

                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="email" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Email
                                </label>
                                : <strong style={{ fontSize: '14px', color: 'darkred', marginLeft: '5px' }}> {formData.email}</strong>
                            </div>

                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="product" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Category Name
                                </label>
                                : <strong style={{ fontSize: '14px', color: 'darkred', marginLeft: '5px' }}> {formData.product || ''}</strong>
                            </div>

                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="serviceRequestTypes" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Brand Name
                                </label>
                                : <strong style={{ fontSize: '14px', color: 'darkred', marginLeft: '5px' }}> {formData.serviceRequestTypes || ''}</strong>
                            </div>

                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="productModel" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Product Model
                                </label>
                                : <strong style={{ fontSize: '14px', color: 'darkblue', marginLeft: '5px' }}> {formData.productModel || ''}</strong>
                            </div>

                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="modal" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Model Serial No
                                </label>
                                : <strong style={{ fontSize: '14px', color: 'darkblue', marginLeft: '5px' }}> {formData.modal || ''}</strong>
                            </div>

                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="warranty" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Call Type
                                </label>
                                :  <strong style={{ fontSize: '14px', color: 'darkblue', marginLeft: '5px' }}> {formData.warranty || ''}</strong>
                            </div>

                            <div className="w-full mb-2 flex items-center">
                                <label className="block tracking-wide text-black text-xs mb-0" htmlFor="remarks" style={{ fontSize: '14px', width: '150px', color: 'darkblue' }}>
                                    Remark
                                </label>
                                :   <strong style={{ fontSize: '14px', color: 'darkblue', marginLeft: '5px' }}> {formData.remarks}</strong>
                            </div>

                        </div>
                    </div>


                    <div className="w-1/2 pl-4">
                        <div className="bg-teal-750 rounded-lg shadow-lg p-6">
                            <div className="w-full mb-4 flex">
                                <div className="ml-4">
                                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px', marginLeft: '-25px', marginTop: '-10px' }}>
                                        <div className="w-full mb-4 flex justify-between items-center">
                                            <h6 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Times New Roman', color: 'purple' }}>SERVICE SCHEDULE</h6>

                                            <div className="flex justify-end items-center" style={{ marginTop: '-40px' }}>
                                                <label className="block tracking-wide text-black text-xs font-bold mb-2 mr-4" htmlFor="toDate" style={{ fontSize: '17px', fontWeight: 'bolder' }}>
                                                    Date
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                    type="date"
                                                    id="toDate"
                                                    name="toDate"
                                                    value={toDate}
                                                    onChange={handleToDateChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="w-full mb-4 flex">
                                            <br />
                                            <Card style={{ marginTop: '-40px' }}>
                                                <CardContent>
                                                    <div style={{ display: 'flex', alignItems: 'center', color: 'green', marginLeft: '45px', fontWeight: 'bolder', fontFamily: 'monospace' }}>Engineer's</div>
                                                    {engineerAvailability.map((item, index) => (
                                                        <div key={index} className="customTableRow" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px', padding: '2px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <TableCell sx={{ fontSize: '16px', padding: '5px' }}>
                                                                    <Checkbox
                                                                        checked={selectedCheckboxIndex === index}
                                                                        onChange={(event) => handleCheckboxChange(event, index)}
                                                                    />
                                                                </TableCell>
                                                                <Typography variant="body1" style={{ marginLeft: '5px', padding: '2px' }}>{item.engineerName}</Typography>
                                                            </div>
                                                            <IconButton onClick={() => handleArrowClick(item.engineerId, index)}>
                                                                <ArrowForward />
                                                                <Typography variant="body1" style={{ marginLeft: '10px' }}>Count: {item.allocatedServiceCount}</Typography>
                                                            </IconButton>


                                                        </div>
                                                    ))}
                                                </CardContent>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
        </Fragment >
    );
};

export default Allocaterequest;
